import {
  signInAnonymously,
  signOut,
  onAuthStateChanged,
  User,
} from "firebase/auth";
import { auth } from "../firebase";

export interface FirebaseAuthResponse {
  success: boolean;
  message: string;
  user?: User;
}

export const authenticateWithFirebase =
  async (): Promise<FirebaseAuthResponse> => {
    try {
      const userSession = localStorage.getItem("userSession");
      const token = localStorage.getItem("token");

      console.log("Verificando autenticação:", {
        hasUserSession: !!userSession,
        hasToken: !!token,
        userSession: userSession ? "presente" : "ausente",
        token: token ? "presente" : "ausente",
      });

      if (!userSession || !token) {
        console.log("Faltam dados de autenticação:", {
          userSession: userSession,
          token: token,
        });
        return {
          success: false,
          message: "Usuário não autenticado no sistema principal",
        };
      }

      try {
        const sessionData = JSON.parse(userSession);
        if (!sessionData || !sessionData.companyId) {
          console.log("Sessão inválida:", sessionData);
          return {
            success: false,
            message: "Sessão inválida no sistema principal",
          };
        }
      } catch (parseError) {
        console.log("Erro ao parsear sessão:", parseError);
        return {
          success: false,
          message: "Sessão corrompida no sistema principal",
        };
      }

      try {
        const userCredential = await signInAnonymously(auth);

        return {
          success: true,
          message: "Usuário autenticado no Firebase - uploads permitidos",
          user: userCredential.user,
        };
      } catch (firebaseError: any) {
        console.error("Erro no login anônimo do Firebase:", firebaseError);

        if (firebaseError.code === "auth/operation-not-allowed") {
          console.log(
            "Login anônimo não habilitado, usando abordagem alternativa"
          );

          return {
            success: true,
            message:
              "Usuário autenticado no sistema principal - uploads permitidos (login anônimo não habilitado)",
            user: undefined,
          };
        }

        return {
          success: false,
          message: `Erro no Firebase: ${firebaseError.message}`,
        };
      }
    } catch (error: any) {
      console.error("Erro na verificação de autenticação:", error);

      return {
        success: false,
        message: "Erro ao verificar autenticação",
      };
    }
  };

export const signOutFromFirebase = async (): Promise<void> => {
  try {
    // Fazer logout do Firebase se estiver autenticado
    if (auth.currentUser) {
      await signOut(auth);
      console.log("Logout do Firebase realizado");
    }

    // Limpar dados da sessão local
    localStorage.removeItem("userSession");
    localStorage.removeItem("token");
    console.log("Logout do sistema principal realizado");
  } catch (error) {
    console.error("Erro ao fazer logout:", error);
  }
};

export const getCurrentFirebaseUser = (): User | null => {
  return auth.currentUser;
};

export const onFirebaseAuthStateChanged = (
  callback: (user: User | null) => void
) => {
  return onAuthStateChanged(auth, callback);
};

export const isFirebaseAuthenticated = (): boolean => {
  const hasFirebaseUser = auth.currentUser !== null;
  const userSession = localStorage.getItem("userSession");
  const token = localStorage.getItem("token");

  if (hasFirebaseUser) {
    return true;
  }

  if (!userSession || !token) {
    return false;
  }

  try {
    const sessionData = JSON.parse(userSession);
    return !!(sessionData && sessionData.companyId);
  } catch (error) {
    console.error("Erro ao verificar sessão:", error);
    return false;
  }
};
